var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"app-container"},[(_vm.currentUserId)?_c('chat-container',{attrs:{"currentUserId":_vm.currentUserId,"theme":_vm.theme,"responsiveBreakpoint":900,"height":"calc(100vh - 150px)"}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }